import {NavLink as ReactRouteNavLink} from 'react-router-dom';
import {useUsers} from "../../../users";
import {
    DashboardWidgetBuilder,
    WidgetDataPoint,
    WidgetType
} from "@flexinet/ui-components";

export const UsersWidget = () => {

    const {
        items,
    } = useUsers()


    const dataPoints: WidgetDataPoint[] = [];
    dataPoints.push({
                        value: items.length,
                        label: 'Users',
                        color: 'flexinet',
                    });


    const widget: WidgetType = {
        header: {
            title: 'Users',
        },
        body: {
            dataPoints: dataPoints,
            metrics: [],
        },
        footer: {
            actionItems: [
                {
                    label: 'View All',
                    description:
                        'View All Users',
                    component: {ReactRouteNavLink},
                    to: '/users',
                    visible: true
                },
                {
                    label: 'Onboard User',
                    description:
                        'Onboard new user',
                    component: {ReactRouteNavLink},
                    to: '/users/add',
                    visible: true,
                },
            ],
        }
    };

    return <DashboardWidgetBuilder widget={widget}/>;
};
